<script setup>
/* Aufklappbarer Filter-Bereich (Kaderseite und Transfers-Seite): die Filtergruppen kommen als Inhalt, "Reset" steht
   darunter und nur, wenn mindestens ein Filter aktiv ist. Zu/offen gesteuert über `open` (v-show: die Filter wirken
   auch bei geschlossenem Bereich). */
defineProps({
  open: { type: Boolean, default: false },
  count: { type: Number, default: 0 },
  id: { type: String, required: true },
});
defineEmits(['reset']);
</script>

<template>
  <div v-show="open" :id="id" class="filter-panel" data-testid="filter-panel">
    <slot />
    <button v-if="count > 0" type="button" class="filter-reset" data-testid="filter-reset" @click="$emit('reset')">
      {{ $t('squad.resetFilters') }}
    </button>
  </div>
</template>

<style scoped>
/* Gruppen untereinander, Abstand wie zwischen den Zeilen der alten Filterleiste */
.filter-panel {
  max-width: 680px;
  margin: 0 auto 16px;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
@media (min-width: 1024px) {
  .filter-panel {
    max-width: 1280px;
  }
}
.filter-reset {
  align-self: flex-start;
  min-height: 40px;
  padding: 0 4px;
  background: none;
  border: 0;
  color: var(--green);
  font: inherit;
  font-size: var(--fs-sm);
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}
.filter-reset:focus-visible {
  outline: 2px solid var(--green);
  outline-offset: 2px;
  border-radius: 4px;
}
</style>
